export const ACTION_TYPE = {
  INITIAL_DATA: "INITIAL_DATA",
  CATEGORY: "CATEGORY",
  ADD_WATCH: "ADD_WATCH",
  REMOVE_WATCH: "REMOVE_WATCH",
  ADD_LIKED: "ADD_LIKED",
  REMOVE_LIKED: "REMOVE_LIKED",
  PLAYLIST: "PLAYLIST",
  VIDEO_PLAYLIST: "VIDEO_PLAYLIST",
  ADD_HISTORY: "ADD_HISTORY",
  SORT_BY: "SORT_BY",
  SEARCH: "SEARCH",
  LOGOUT: "LOGOUT",
};
